import store from '@state/store'


// auth related routes
const authRoutes = [
  {
    path: '/noauth',
    name: 'noauth',
    props: (route) => ({ name: route.query.name }),
    component: () => lazyLoadView(import('@views/pages/start')),
  },
  {
    path: '/oauth2/login',
    name: 'oauth2',
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    props: (route) => ({ code: route.query.code }),
    component: () => lazyLoadView(import('@views/pages/auth/oauth')),
    // store.commit('SET_CURRENT_USER', { token: validUserExample.token })

    // meta: {
    //   beforeResolve(routeTo, routeFrom, next) {

    //     // If the user is already logged in
    //     if (store.getters['auth/loggedIn']) {
    //       // Redirect to the home page instead
    //       next({ name: 'dashboard' })
    //     } else {
    //       // Continue to the login page
    //       next()
    //     }
    //   },
    // },
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => lazyLoadView(import('@views/pages/account/register')),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters['auth/loggedIn']) {
  //         // Redirect to the home page instead
  //         next({ name: 'dashboard' })
  //       } else {
  //         // Continue to the login page
  //         next()
  //       }
  //     },
  //   },
  // },
  // {
  //   path: '/confirm-account',
  //   name: 'confirm-account',
  //   component: () => lazyLoadView(import('@views/pages/account/confirm')),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters['auth/loggedIn']) {
  //         // Redirect to the home page instead
  //         next({ name: 'dashboard' })
  //       } else {
  //         // Continue to the login page
  //         next()
  //       }
  //     },
  //   },
  // },
  // {
  //   path: '/forget-password',
  //   name: 'forget-password',
  //   component: () =>
  //     lazyLoadView(import('@views/pages/account/forgetPassword')),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters['auth/loggedIn']) {
  //         // Redirect to the home page instead
  //         next({ name: 'dashboard' })
  //       } else {
  //         // Continue to the login page
  //         next()
  //       }
  //     },
  //   },
  // },
  // {
  //   path: '/logout',
  //   name: 'logout',
  //   meta: {
  //     authRequired: true,
  //     beforeResolve(routeTo, routeFrom, next) {
  //       store.dispatch('auth/logOut')
  //       const authRequiredOnPreviousRoute = routeFrom.matched.some(
  //         (route) => route.meta.authRequired
  //       )
  //       // Navigate back to previous page, or home as a fallback
  //       next(
  //         authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom }
  //       )
  //     },
  //   },
  // },
]

// auth related routes
// const authRoutes = [
//   {
//     path: '/login',
//     name: 'login',
//     component: () => lazyLoadView(import('@views/pages/account/login')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/register',
//     name: 'register',
//     component: () => lazyLoadView(import('@views/pages/account/register')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/confirm-account',
//     name: 'confirm-account',
//     component: () => lazyLoadView(import('@views/pages/account/confirm')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/forget-password',
//     name: 'forget-password',
//     component: () =>
//       lazyLoadView(import('@views/pages/account/forgetPassword')),
//     meta: {
//       beforeResolve(routeTo, routeFrom, next) {
//         // If the user is already logged in
//         if (store.getters['auth/loggedIn']) {
//           // Redirect to the home page instead
//           next({ name: 'dashboard' })
//         } else {
//           // Continue to the login page
//           next()
//         }
//       },
//     },
//   },
//   {
//     path: '/logout',
//     name: 'logout',
//     meta: {
//       authRequired: true,
//       beforeResolve(routeTo, routeFrom, next) {
//         store.dispatch('auth/logOut')
//         const authRequiredOnPreviousRoute = routeFrom.matched.some(
//           (route) => route.meta.authRequired
//         )
//         // Navigate back to previous page, or home as a fallback
//         next(
//           authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom }
//         )
//       },
//     },
//   },
// ]

// error pages
const errorPagesRoutes = [
  {
    path: '/404',
    name: '404',
    component: require('@views/pages/secondary/error-404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/500',
    name: '500',
    component: require('@views/pages/secondary/error-500').default,
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/',
    props: (route) => ({ code: route.query.code }),
    component: () => lazyLoadView(import('@views/pages/frontdoor')),
    meta: { requiresAuth: false, hideFromMenu: true },
  },
  {
    path: '/dashboard',
    name: 'Home',
    group: 'Overview',
    groupIcon: 'home',
    icon: 'home',
    // badge: {
    //   text: '1',
    //   varient: 'success',
    // },
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    props: (route) => ({ name: route.query.name }),
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
  },
]

// incidents
const incidentsAllRoutes = [
  {
    path: '/incidents/all',
    name: 'All Incidents',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    header: 'Incidents',
    icon: 'eye',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/incidents/all')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const incidentsSearchRoutes = [
    {
      path: '/incidents/lists',
      name: 'Filtered',
      icon: 'search',
      meta: { requiresAuth: true },
      component: {
        render(c) {
          return c('router-view')
        },
      },
      // props: (route) => ({ user: store.state.auth.currentUser || {} }),
      children: [
        {
          name: 'Open',
          path: 'open',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/open')),
        },
        {
          name: 'Closed',
          path: 'closed',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/closed')),
        },
        {
          name: 'False Positives',
          path: 'false_positives',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/false_positives')),
        },
        {
          name: 'Handled',
          path: 'handled',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/handled')),
        },
        {
          name: 'Other',
          path: 'other',
          meta: { requiresAuth: true },
          component: () =>
            lazyLoadView(import('@views/pages/apps/incidents/other')),
        },
      ],
    }
  ];

const incidentsCreateRoutes = [
  {
    path: '/apps/email',
    name: 'Add',
    icon: 'plus',
    meta: { requiresAuth: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        name: 'Inbox',
        path: 'inbox',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/email/inbox')),
      },
      {
        path: 'read',
        name: 'Read Email',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/email/reademail')),
      },
      {
        path: 'compose',
        name: 'Compose Email',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/email/emailcompose')),
      },
    ],
  }
];

const incidentsTriageRoutes = [
  {
    path: '/incidents/triage',
    name: 'Triage',
    icon: 'alert-triangle',
    meta: { requiresAuth: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'unassigned',
        name: 'Unassigned',
        meta: { requiresAuth: true },
        component: () =>
          lazyLoadView(import('@views/pages/apps/incidents/triage')),
      },
    ],
  }
];

const incidentsStatsRoutes = [
  {
    path: '/incidents/stats',
    name: 'Stats',
    icon: 'activity',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/incidents/stats')),
  }
]

const incidentsRoutes = [
  ...incidentsAllRoutes,
  ...incidentsSearchRoutes,
  // ...incidentsTriageRoutes,
  // ...incidentsCreateRoutes
  ...incidentsStatsRoutes
]

const alertsAllRoutes = [
  {
    path: '/alerts/all',
    name: 'All Alerts',
    header: 'Alerts',
    icon: 'bell',
    component: () => lazyLoadView(import('@views/pages/apps/alerts/all')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];


const alertsGroupedRoutes = [
  {
    path: '/alerts/grouped',
    name: 'Grouped',
    icon: 'grid',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    header: 'Alerts',
    component: () => lazyLoadView(import('@views/pages/apps/alerts/grouped')),
    meta: { requiresAuth: true },
  }
];

const alertsRoutes = [
  // ...alertsAllRoutes,
  ...alertsGroupedRoutes,
]

const actionsRoutes = [
  {
    path: '/actions/view',
    name: 'View Actions',
    header: 'Actions',
    icon: 'settings',
    component: () => lazyLoadView(import('@views/pages/apps/assets/all')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

// assets

const suspectAssetsRoutes = [
  {
    path: '/assets/suspects',
    name: 'Suspects',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    header: 'Assets',
    icon: 'alert-octagon',
    component: () => lazyLoadView(import('@views/pages/apps/assets/suspects')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const isolatedAssetsRoutes = [
  {
    path: '/assets/isolated',
    name: 'Isolated',
    icon: 'minimize',
    component: () => lazyLoadView(import('@views/pages/apps/assets/isolated')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const allAssetsRoutes = [
  {
    path: '/assets/all',
    name: 'All Assets',
    icon: 'package',
    component: () => lazyLoadView(import('@views/pages/apps/assets/all')),
    meta: { requiresAuth: true },
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
];

const assetsRoutes = [
  ...suspectAssetsRoutes,
  // ...isolatedAssetsRoutes,
  ...allAssetsRoutes,
]
// indicators

const allIndicatorsRoutes = [
  {
    path: '/indicators/all',
    name: 'All Indicators',
    icon: 'package',
    group: 'Threat Intelligence',
    groupIcon: 'crosshair',
    header: 'Indicators',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/indicators/all')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const dangerousIndicatorsRoutes = [
  {
    path: '/indicators/dangerous',
    name: 'Dangerous',
    icon: 'alert-octagon',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/indicators/dangerous')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const intelIndicatorsRoutes = [
  {
    path: '/indicators/intel',
    name: 'Intelligence',
    icon: 'crosshair',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/indicators/intel')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const otxIndicatorsRoutes = [
  {
    path: '/indicators/otx',
    name: 'AlienVault OTX',
    icon: 'eye',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/indicators/otx')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]


const indicatorsRoutes = [
  ...allIndicatorsRoutes,
  ...dangerousIndicatorsRoutes,
  ...intelIndicatorsRoutes,
  ...otxIndicatorsRoutes
]

const domainsAlarmsRoutes = [
  {
    path: '/purpleteaming/domains/registration/alarms',
    group: 'Threat Intelligence',
    groupIcon: 'crosshair',
    header: 'Domain Monitoring',
    name: 'Alarms',
    icon: 'alert-octagon',
    meta: {
      requiresAuth: true,
    },
    component: () =>
      lazyLoadView(import('@views/pages/apps/domains/registration/alarms')),
  },
]

const domainsChecksRoutes = [
  {
    path: '/purpleteaming/domains/registration/checks',
    name: 'Checks',
    icon: 'eye',
    meta: {
      requiresAuth: true,
    },
    component: () =>
      lazyLoadView(import('@views/pages/apps/domains/registration/checks')),
  },
]

const domainsRoutes = [...domainsAlarmsRoutes, ...domainsChecksRoutes]

const credentialBreachesRoutes = [
  {
    path: '/purpleteaming/credentials/breaches',
    group: 'Threat Intelligence',
    groupIcon: 'crosshair',
    header: 'Credential Monitoring',
    name: 'Breaches',
    icon: 'alert-octagon',
    meta: {
      requiresAuth: true,
    },
    component: () =>
      lazyLoadView(import('@views/pages/apps/credentials/breaches')),
  },
  {
    path: '/purpleteaming/credentials/breaches/vip',
    name: 'Breaches VIP',
    icon: 'alert-octagon',
    meta: {
      requiresAuth: true,
    },
    component: () =>
      lazyLoadView(import('@views/pages/apps/credentials/breaches_vip'))
  }
]

const credentialChecksRoutes = [
  {
    path: '/purpleteaming/credentials/checks',
    name: 'Checks',
    icon: 'eye',
    meta: {
      requiresAuth: true,
    },
    component: () =>
      lazyLoadView(import('@views/pages/apps/credentials/checks'))
  },
  {
    path: '/purpleteaming/credentials/checks/vip',
    name: 'Checks VIP',
    icon: 'eye',
    meta: {
      requiresAuth: true,
    },
    component: () =>
      lazyLoadView(import('@views/pages/apps/credentials/checks_vip'))
  }
]

const credentialsRoutes = [...credentialBreachesRoutes, ...credentialChecksRoutes]

// services
const reportCustomMDRRoute = [
  {
    path: '/reports/mdr/custom',
    name: 'MDR General',
    icon: 'file',
    group: 'Reports & Insights',
    groupIcon: 'file-text',
    header: 'Reports',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/general_report_mdr')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const reportByCompanyMDRRoute = [
  {
    path: '/reports/mdr/bycompany',
    name: 'MDR By Company',
    icon: 'briefcase',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/by_company_report_mdr')),
    // props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const reportGeneralOffice365Route = [
  {
    path: '/reports/office365/general',
    name: 'Office365',
    icon: 'package',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/general_report_office365')),
  },
]

const reportAvailabilityPANRoute = [
  {
    path: '/reports/pan/availability',
    name: 'PAN NGFW Ava.',
    icon: 'globe',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/dashboard/availability_report_pan')),
  },
]

const reportRoutes = [
  ...reportCustomMDRRoute,
  ...reportByCompanyMDRRoute,
  ...reportGeneralOffice365Route,
  ...reportAvailabilityPANRoute
]

// services
const serviceAlertsRoutes = [
  {
    path: '/service/alerts',
    name: 'Alerts',
    icon: 'bell',
    group: 'Service & Configuration',
    groupIcon: 'settings',
    header: 'Service Health',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/service/alerts')),
  },
]

const serviceStatusRoutes = [
  {
    path: '/service/sla',
    name: 'SLA',
    icon: 'activity',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/service/sla')),
  },
]

const serviceLevelObjectivesRoutes = [
  {
    path: '/service/slo',
    name: 'SLO',
    icon: 'briefcase',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/service/slo')),
  },
]

const serviceRoutes = [
  ...serviceAlertsRoutes,
  ...serviceStatusRoutes,
  ...serviceLevelObjectivesRoutes,
]

// recommendations
const recommendationAllRoutes = [
  {
    path: '/recommendations/all',
    name: 'All',
    icon: 'coffee',
    group: 'Reports & Insights',
    groupIcon: 'file-text',
    header: 'Recommendations',
    meta: { requiresAuth: true, requiresUserGroups: ["360aaa", "360sec", "360"] },
    component: () => lazyLoadView(import('@views/pages/apps/recommendations/all')),
  },
]

const recommendationFilteredRoutes = [
  {
    path: '/recommendations/filtered',
    name: 'Filtered',
    icon: 'coffee',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/recommendations/filtered')),
  },
]

const recommendationsRoutes = [
  ...recommendationAllRoutes,
]


// tables
// const tablesRoutes = [
//   {
//     path: '/tables',
//     name: 'Tables',
//     icon: 'grid',
//     meta: { authRequired: true },
//     // create a container component
//     component: {
//       render(c) {
//         return c('router-view')
//       },
//     },
//     children: [
//       {
//         path: 'basic',
//         name: 'Basic Tables',
//         component: () =>
//           lazyLoadView(import('@views/pages/ui/tables/basic-table')),
//       },
//       {
//         path: 'advanced',
//         name: 'Advanced Tables',
//         component: () =>
//           lazyLoadView(import('@views/pages/ui/tables/advanced-table')),
//       },
//     ],
//   },
// ]

// // charts
// const chartsRoutes = [
//   {
//     path: '/charts',
//     name: 'Charts',
//     icon: 'pie-chart',
//     component: () => lazyLoadView(import('@views/pages/ui/chart/')),
//     meta: { authRequired: true },
//     props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   },
// ]

const dataNetworksRoutes = [
  {
    path: '/data/networks',
    name: 'Networks',
    icon: 'globe',
    group: 'Service & Configuration',
    groupIcon: 'settings',
    header: 'Reference Data',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/data/all_networks')),
  },
]

const dataRoutes = [
  ...dataNetworksRoutes,
]

const entraIDRoutesRisks = [
  {
    path: '/entra_id/all',
    name: 'Entra ID Risks',
    icon: 'sun',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    header: 'Identity & Cloud',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/entra_id/all_risks')),
  },
]

const entraIDRoutes = [...entraIDRoutesRisks]

const intuneRoutesWipeAlerts = [
  {
    path: '/intune/wipe_alerts',
    name: 'Intune Wipe Alerts',
    icon: 'alert-triangle',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/intune/all_wipe_alerts')),
  },
]

const intuneRoutes = [...intuneRoutesWipeAlerts]

const office365EventsRoutes = [
  {
    path: '/office365/events',
    name: 'O365 Events',
    icon: 'sun',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/office365/all_events')),
  },
]

const office365EventsAlarms = [
  {
    path: '/office365/events/alarms',
    name: 'O365 Alarms',
    icon: 'bell',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/office365/all_alarms')),
  },
]

const sharepointAuditEventsRoutes = [
  {
    path: '/sharepoint/audit_events',
    name: 'SharePoint Audit',
    icon: 'folder',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/sharepoint/all_events')),
  },
]

const sharepointRoutes = [...sharepointAuditEventsRoutes]

const office365Routes = [
  ...office365EventsRoutes,
  ...office365EventsAlarms
]


const automationLogsRoute = [
  {
    path: '/automation/events',
    name: 'Events',
    icon: 'bell',
    group: 'Detect & Respond',
    groupIcon: 'shield',
    header: 'Automation',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/auto/events')),
  },
]

const automationStatsRoute = [
  {
    path: '/automation/stats',
    name: 'Stats',
    icon: 'activity',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/auto/stats')),
  },
]

const automationExclusionsIP = [
  {
    path: '/automation/exclusions/ip',
    name: 'IP Exclusions',
    icon: 'alert-octagon',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/auto/exclusions/ip')),
  },
]

const automationExclusionsNames = [
  {
    path: '/automation/exclusions/names',
    name: 'Name Exclusions',
    icon: 'alert-octagon',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/auto/exclusions/names')),
  }
]

const automationExclusionsURLs = [
  {
    path: '/automation/exclusions/urls',
    name: 'URLs Exclusions',
    icon: 'alert-octagon',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/auto/exclusions/urls'))
  }
]

const automationEDLs = [
  {
    path: '/automation/edls',
    name: 'EDLs',
    icon: 'list',
    meta: { requiresAuth: true },
    component: () =>
      lazyLoadView(import('@views/pages/apps/auto/edls'))
  }
]

const automationAdvisories = [
  {
    path: '/automation/advisories',
    name: 'Advisories',
    icon: 'bell',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/auto/advisories')),
  },
]

const automationRoutes = [
  ...automationLogsRoute,
  ...automationStatsRoute,
  ...automationEDLs,
  ...automationExclusionsIP,
  ...automationExclusionsNames,
  ...automationExclusionsURLs,
  ...automationAdvisories]

const tenableScansRoute = [
  {
    path: '/tenable/scans',
    name: 'Scans',
    icon: 'shield',
    group: 'Vulnerability Management',
    groupIcon: 'shield-off',
    header: 'On-Premises',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/tenable/scans')),
  },
]

const tenableAssetsRoute = [
  {
    path: '/tenable/assets',
    name: 'Assets',
    icon: 'box',
    component: () => import('@views/pages/apps/tenable/assets'),
    meta: { title: 'Tenable Assets', authRequired: true },
  },
]

const tenableVulnerabilitiesRoute = [
  {
    path: '/tenable/vulnerabilities',
    name: 'Vulnerabilities',
    icon: 'shield-off',
    component: () => lazyLoadView(import('@views/pages/apps/tenable/vulnerabilities')),
    meta: { requiresAuth: true },
  },
]

const tenableVulnerabilitiesAssetsRoute = [
  {
    path: '/tenable/vulnerabilities_assets',
    name: 'Vuln Assets',
    icon: 'shield-off',
    component: () => lazyLoadView(import('@views/pages/apps/tenable/vulnerabilities_assets')),
    meta: { requiresAuth: true },
  },
]

const tenableRoutes = [
  ...tenableScansRoute,
  ...tenableAssetsRoute,
  ...tenableVulnerabilitiesRoute,
  ...tenableVulnerabilitiesAssetsRoute
]

// Prisma Cloud Routes
const prismaCloudVulnerabilitiesRoute = [
  {
    path: '/prismacloud/vulnerabilities',
    name: 'Vulnerabilities',
    icon: 'shield',
    group: 'Vulnerability Management',
    groupIcon: 'shield-off',
    header: 'Cloud Workloads',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/prismacloud/dashboard')),
  },
]

const prismaCloudAssetsRoute = [
  {
    path: '/prismacloud/assets',
    name: 'Assets',
    icon: 'server',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/prismacloud/assets')),
  },
]

const prismaCloudPriorityRemediationRoute = [
  {
    path: '/prismacloud/priorityremediation',
    name: 'Priority Remediation',
    icon: 'alert-octagon',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/prismacloud/hallofshame')),
  },
]

const prismaCloudRoutes = [
  ...prismaCloudVulnerabilitiesRoute,
  ...prismaCloudAssetsRoute,
  ...prismaCloudPriorityRemediationRoute,
]

// Monitoring Routes (PAN-OS firewalls uptime/HA + SD-WAN + ACC tops)
const monitoringFirewallsRoute = [
  {
    path: '/monitoring/firewalls',
    name: 'Firewalls',
    icon: 'server',
    group: 'Monitoring',
    groupIcon: 'activity',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/monitoring/firewalls_page')),
  },
]

const monitoringSdwanRoute = [
  {
    path: '/monitoring/sdwan',
    name: 'SD-WAN',
    icon: 'git-branch',
    group: 'Monitoring',
    groupIcon: 'activity',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/monitoring/sdwan_page')),
  },
]

const monitoringAccRoute = [
  {
    path: '/monitoring/acc',
    name: 'ACC',
    icon: 'pie-chart',
    group: 'Monitoring',
    groupIcon: 'activity',
    meta: { requiresAuth: true },
    component: () => lazyLoadView(import('@views/pages/apps/monitoring/acc_page')),
  },
]

const monitoringRoutes = [
  ...monitoringFirewallsRoute,
  ...monitoringSdwanRoute,
  ...monitoringAccRoute,
]

const authProtectedRoutes = [
  // 1. Overview
  ...dashboardRoutes,
  // 2. Detect & Respond
  ...incidentsRoutes,
  ...alertsRoutes,
  ...assetsRoutes,
  ...entraIDRoutes,
  ...intuneRoutes,
  ...office365Routes,
  ...sharepointRoutes,
  ...automationRoutes,
  // 3. Monitoring
  ...monitoringRoutes,
  // 4. Threat Intelligence
  ...indicatorsRoutes,
  ...domainsRoutes,
  ...credentialsRoutes,
  // 5. Vulnerability Management
  ...tenableRoutes,
  ...prismaCloudRoutes,
  // 6. Reports & Insights
  ...reportRoutes,
  ...recommendationsRoutes,
  // 7. Service & Configuration
  ...serviceRoutes,
  ...dataRoutes,
]
const allRoutes = [...authRoutes, ...authProtectedRoutes, ...errorPagesRoutes]
// const allRoutes = [...authProtectedRoutes, ...errorPagesRoutes]
// const allRoutes = [...authProtectedRoutes, ...errorPagesRoutes]
// const allRoutes = [...authProtectedRoutes, ...errorPagesRoutes]

export { allRoutes, authProtectedRoutes }

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@components/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    // error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
